import { Button, Card, Chip, Divider, Icons, Stack, Typography } from '@healthinal/ui';
import { differenceInMilliseconds } from 'date-fns';
import { useState } from 'react';
import { ImagingDiagnosisDto } from '../../../../../api/generated/model';
import { SubCard } from '../../../../../components/SubCard.tsx';
import { getImagingProcedureTypenName } from '../../../../../utils/anamnesis.ts';
import { formatDateWithGermanMonth } from '../../../../../utils/date.ts';
import { FileLink } from '../../../../components/FileLink.tsx';
import { AddImagingDiagnosisDialog } from './AddImagingDiagnosisDialog.tsx';

export function ImagingDiagnosisCard({
  diagnoses,
  anamnesisId,
  patientId,
}: {
  diagnoses?: ImagingDiagnosisDto[] | null;
  anamnesisId: string;
  patientId: string;
}) {
  const [isAddImagingDiagnosisDialogOpen, setIsAddImagingDiagnosisDialogOpen] = useState(false);

  return (
    <>
      <Card>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography level={'title-lg'}>Bildgebende Diagnose</Typography>
          <Button onClick={() => setIsAddImagingDiagnosisDialogOpen(true)} endDecorator={<Icons.Add />}>
            Diagnose hinzufügen
          </Button>
        </Stack>
        <Divider />
        {diagnoses?.length ? (
          <Stack gap={2}>
            {[...diagnoses]
              .sort((a, b) => differenceInMilliseconds(b.date, a.date))
              .map((diagnosis) => (
                <SubCard key={diagnosis.id}>
                  <Stack direction={'row'} gap={1}>
                    <Stack flex={1}>
                      <Chip color={'success'} variant={'solid'}>
                        {getImagingProcedureTypenName(diagnosis.imagingProcedure)}
                      </Chip>
                    </Stack>
                    <Typography flex={3} level={'body-sm'} alignSelf={'center'}>
                      {formatDateWithGermanMonth(diagnosis.date)}
                    </Typography>
                  </Stack>
                  <Divider />
                  <Stack direction={'row'} gap={2}>
                    <Typography flex={1} level={'title-sm'}>
                      Datei
                    </Typography>
                    {diagnosis.fileDetails && <FileLink flex={3} fileDetails={diagnosis.fileDetails} />}
                  </Stack>
                  <Stack direction={'row'} gap={2}>
                    <Typography flex={1} level={'title-sm'}>
                      Befund
                    </Typography>
                    <Typography flex={3} level={'title-sm'} alignSelf={'center'} sx={{ whiteSpace: 'pre-line' }}>
                      {diagnosis.imagingFinding}
                    </Typography>
                  </Stack>
                </SubCard>
              ))}
          </Stack>
        ) : (
          <Stack alignItems={'center'} gap={1} p={3}>
            <Icons.Description />
            <Typography level="body-sm">Noch keine Bildgebende Diagnose vorhanden.</Typography>
          </Stack>
        )}
      </Card>
      <AddImagingDiagnosisDialog
        open={isAddImagingDiagnosisDialogOpen}
        onClose={() => setIsAddImagingDiagnosisDialogOpen(false)}
        anamnesisId={anamnesisId}
        patientId={patientId}
      />
    </>
  );
}
